import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailCodeBoxComponent } from '../../components/email-codebox/email-codebox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-email-verification-code.component.less'],
  templateUrl: './tellent-email-verification-code.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailCodeBoxComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentEmailVerificationCodeTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentEmailVerificationCodeTemplateData>;
}

export type TellentEmailVerificationCodeTemplateData = {
  avatar_url: string;
  header: string;
  subheader: string;
  text: string;
  footer: {
    text: string;
    label: string;
  };
  code: string;
};

export const TellentEmailVerificationCodeTemplateMocks: TellentEmailVerificationCodeTemplateData[] =
  [
    {
      avatar_url:
        'https://recruitee-staging.s3.eu-central-1.amazonaws.com/admins/45690/thumb_avatar_hcwhs58oldbe.jpg',
      header: 'Verification code',
      subheader: 'Here is your verification code for Tellent.',
      text: 'Please don’t share this code with anyone.',
      code: '341235',
      footer: {
        text: 'Need help?',
        label: 'support@tellent.com',
      },
    },
  ];
